exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Title-module__container--aqMKt {\r\n  width: 100%;\r\n  padding: 16px 16px 13px 16px;\r\n  background-color: #ffffff;\r\n  border-bottom: 1px solid #dddddd;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.Title-module__title--3V1l9 {\r\n  font-size: 16px;\r\n  color: #333333;\r\n  font-weight: bold;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "Title-module__container--aqMKt",
	"title": "Title-module__title--3V1l9"
};